import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API } from '@/utils/API';

interface InvitationData {
  email: string;
  role_key: string;
}

const fetchInvitation = async (token: string) => {
  const response = await API.fetch(`/invitations/${token}`);
  if (!response.ok) {
    throw new Error('Invitation not found or has expired.');
  }
  return response.json();
};

export const useInvitation = () => {
  const [searchParams] = useSearchParams();
  const [InvitationData, setInvitationData] = useState<InvitationData | null>(
    null
  );
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setError('No invitation token provided.');
      setLoading(false);
      return;
    }

    const getInvitation = async () => {
      try {
        const data = await fetchInvitation(token);
        setInvitationData(data);
      } catch (_err) {
        setError('This invitation is invalid or has expired.');
      } finally {
        setLoading(false);
      }
    };

    getInvitation();
  }, [token]);

  return { InvitationData, error, loading, token };
};
